module.exports = __webpack_public_path__ + "img/213476703.078aa3f0.gif";